import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    IHourlyWageCreate,
    IHourlyWagePayload
} from "../types";
import request from "../../../../../../../service";
import {IErrorResponse} from "../../../../../../../types";
import {
    deletedRestoreHourlyWage,
    deleteHourlyWage,
    setHourlyWage, setRestoreHourlyWage, updateHourlyWage
} from "./hourlyWageSlice";




const CreateHourlyWage= createAsyncThunk(
    "create/hourly/wage",
    async (payload: IHourlyWageCreate, { rejectWithValue }) => {
        try {
            const response = await request.post("/hour-rates", payload);

            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const GetHourlyWage = createAsyncThunk(
    "get/hourly/wage",
    async (_, { dispatch, rejectWithValue, }) => {
        try {
            const response = await request.get("/hour-rates");

            dispatch(setHourlyWage(response.data));
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);





const DeleteHourlyWage = createAsyncThunk(
    "delete/hourly/wage",
    async (id:number ,{dispatch,rejectWithValue}) => {
        try {
            const response = await request.delete(`/hour-rates/${id}`);
            dispatch(deleteHourlyWage(id));
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;

            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);


const EditHourlyWage = createAsyncThunk(
    "edit/hourly/wage",
    async ( data : IHourlyWagePayload, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.put(`/hour-rates/${data.id}`, data);
            dispatch(updateHourlyWage(response.data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);



const GetDeleteHourlyWage = createAsyncThunk(
    "get/deleted/hourly/wage",
    async (_,{ dispatch,rejectWithValue }) => {
        try {
            const response = await request.get(`/hour-rates/deleted-items`);
            dispatch(setRestoreHourlyWage(response.data));
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);

const RestoreHourlyWage= createAsyncThunk(
    "restore/hourly/wage",
    async (id:number,{ dispatch,rejectWithValue }) => {
        try {
            const response = await request.post(`/hour-rates/restore/${id}`);
            dispatch(deletedRestoreHourlyWage(id));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);



export {
    CreateHourlyWage,
    GetHourlyWage,
    EditHourlyWage,
    DeleteHourlyWage,
    GetDeleteHourlyWage,
    RestoreHourlyWage
};
